export const SET_CALLS_FOR_TENDER = "Setzt die Calls for Tender Liste";
export const SET_CURRENT_CALL_FOR_TENDERS =
  "Setzt die aktuelle Call For Tenders";
export const SET_LOCK = "Setze das callForTenders Lock";
